"use strict";
// invariants for the entity goes here
module.exports = entity => entity;
